var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-check" }, [
    _c("input", {
      directives: [
        {
          name: "indeterminate",
          rawName: "v-indeterminate",
          value: _vm.isIndeterminate,
          expression: "isIndeterminate",
        },
      ],
      staticClass: "form-check-input",
      attrs: {
        id: _vm.id,
        type: "checkbox",
        disabled: _vm.isDisabled,
        required: _vm.isRequired,
        "aria-required": _vm.isRequired ? "true" : undefined,
      },
      domProps: { checked: _vm.modelValue },
      on: { change: _vm.onChange },
    }),
    _vm._v(" "),
    _c("label", {
      directives: [
        {
          name: "safe-html",
          rawName: "v-safe-html",
          value: _vm.isListItem ? "" : _vm.label,
          expression: "isListItem ? '' : label",
        },
      ],
      staticClass: "form-check-label",
      attrs: { "aria-label": _vm.ariaLabel, for: _vm.id },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }